// import { usePR } from './usePR';
import { usePRMock } from './usePRMock';

// Demo configuration - set to true to use mock data
const USE_MOCK_DATA = true;

export const usePRDemo = (dateRange) => {
  // Call both hooks unconditionally
  const realData = null;
  const mockData = usePRMock(dateRange);
  
  // Return the appropriate one based on config
  return USE_MOCK_DATA ? mockData : realData;
};